<div class="regions-carousel">
  @if (shouldDisplayLoader) {
    <div class="carousel-skeleton">
      <div class="carousel-item-skeleton"></div>
      <div class="carousel-item-skeleton"></div>
      <div class="carousel-item-skeleton"></div>
      <div class="carousel-item-skeleton"></div>
      <div class="carousel-item-skeleton"></div>
      <div class="carousel-item-skeleton carousel-item-skeleton_last"></div>
    </div>
  } @else {
    <app-regions-carousel-viewer
      [elementScrollManagerById$]="elementScrollManagerById$.asObservable()"
      [elementScrollManagerByName$]="elementScrollManagerByName$.asObservable()"
      [carouselItems$]="brainParts$"
      (slideChanged)="slideChanged($event)"
    ></app-regions-carousel-viewer>
  }
</div>
